// Error Messages
export const ERROR_MESSAGES = {
  REQUIRED: "This field is required",
  INVALID_FORMAT: "Invalid format",
  TOO_SHORT: "Too short",
  TOO_LONG: "Too long",
  PASSWORDS_DONT_MATCH: "Passwords do not match",
  INVALID_DATE: "Invalid date selected",
  PAST_DATE: "Cannot select past date",
  INVALID_TIME_SLOT: "Invalid time slot selected",
  FILE_TOO_LARGE: "File size too large",
  INVALID_FILE_TYPE: "Invalid file type",
  NETWORK_ERROR: "Network error. Please try again.",
  SERVER_ERROR: "Server error. Please try again later.",
  UNAUTHORIZED: "Please login to continue",
  FORBIDDEN: "You do not have permission to perform this action",
};

// Success Messages
export const SUCCESS_MESSAGES = {
  REGISTRATION_SUCCESS:
    "Registration successful! Please verify your phone number.",
  LOGIN_SUCCESS: "Login successful!",
  OTP_SENT: "OTP sent successfully",
  OTP_VERIFIED: "Phone number verified successfully",
  APPOINTMENT_BOOKED: "Consultation booked successfully!",
  APPOINTMENT_CANCELLED: "Consultation cancelled successfully",
  PAYMENT_SUCCESS: "Payment completed successfully!",
  PROFILE_UPDATED: "Profile updated successfully",
  PASSWORD_CHANGED: "Password changed successfully",
  SESSION_COMPLETED: "Session completed successfully",
  FILE_UPLOADED: "File uploaded successfully",
};

// Info Messages
export const INFO_MESSAGES = {
  LOADING: "Loading...",
  PROCESSING: "Processing...",
  SAVING: "Saving...",
  UPLOADING: "Uploading...",
  SENDING: "Sending...",
  VERIFYING: "Verifying...",
  PLEASE_WAIT: "Please wait...",
};
